module.exports = __webpack_public_path__ + "img/24.0a2de48e.png";